import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '@/integrations/supabase/client'

export default function AuthCallback() {
  const navigate = useNavigate()

  useEffect(() => {
    supabase.auth.getSession().then(async ({ data: { session } }) => {
      if (session) {
        const { data: profile, error } = await supabase
          .from('profiles')
          .select('user_id, username, avatar_url, onboarding_complete')
          .eq('user_id', session.user.id)
          .maybeSingle()

        let resolvedProfile = profile
        if (error && error.code === 'PGRST204' && error.message.includes('onboarding_complete')) {
          const { data: fallbackProfile } = await supabase
            .from('profiles')
            .select('user_id, username, avatar_url')
            .eq('user_id', session.user.id)
            .maybeSingle()
          resolvedProfile = fallbackProfile
        }

        // Backwards compatible: if onboarding_complete doesn't exist yet, rely on username.
        const username = resolvedProfile?.username?.trim() ?? ''
        const isOnboarded = (resolvedProfile?.onboarding_complete ?? false) || Boolean(username)

        if (!isOnboarded) {
          const nextStep = resolvedProfile?.avatar_url ? 6 : 5
          navigate(`/signup?step=${nextStep}`, { replace: true })
          return
        }

        navigate('/dashboard', { replace: true })
      } else {
        navigate('/login', { replace: true })
      }
    })
  }, [navigate])

  return (
    <div className="flex items-center justify-center h-screen bg-gray-950 text-white">
      <p>Signing you in...</p>
    </div>
  )
}
